import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import getAdmins from "../api/getAdmins";
import useRolePermission from "../hooks/useRolePermission";

const QUERY_KEY = ["adminList"];

const useAdminListQuery = () => {
  const readAccess = useRolePermission("rolesAndPermissions:read");

  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: getAdmins,
    enabled: Boolean(readAccess.allowed),
  });
};

export default useAdminListQuery;

export const invalidateAdminListQuery = async () => {
  await queryClient.invalidateQueries({
    queryKey: QUERY_KEY,
  });
};
